// extracted by mini-css-extract-plugin
export default {"container":"style_container__7GRpF","backgroundImg":"style_backgroundImg__cmbaW","titleBox":"style_titleBox__I6fpZ"};